import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { BarChart4, CalendarClock, CreditCard, Users, ClipboardList, Warehouse, MessageCircle, FileText } from 'lucide-react';

const ProofSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="proof" className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-900">
            Entdecke unbegrenzte Möglichkeiten für dein Unternehmen
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            Maßgeschneiderte Business-Anwendungen, die perfekt zu deinen spezifischen Geschäftsanforderungen passen
          </p>
        </div>
        
        {/* Applikationsbeispiele */}
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <BarChart4 className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Business Dashboards</h4>
              <p className="text-gray-600">
                Echtzeit-Übersicht über alle wichtigen KPIs und Geschäftszahlen in einem personalisierten Dashboard.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <CreditCard className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Rechnungsmanagement</h4>
              <p className="text-gray-600">
                Automatisiertes Erstellen, Versenden und Verfolgen von Rechnungen mit direkter ERP-Anbindung.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <CalendarClock className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Projektplanung</h4>
              <p className="text-gray-600">
                Ressourcenplanung, Aufgabenverwaltung und Fortschrittsverfolgung für alle Unternehmensprojekte.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Users className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Kundenmanagement</h4>
              <p className="text-gray-600">
                Kundendaten, Interaktionshistorie und Verkaufschancen in einem zentralen, benutzerfreundlichen System.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <ClipboardList className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Auftragsverarbeitung</h4>
              <p className="text-gray-600">
                Digitalisierte Bestellabwicklung von der Anfrage bis zur Lieferung, inklusive Statusverfolgung.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Warehouse className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Lagerbestandsmanagement</h4>
              <p className="text-gray-600">
                Automatische Bestandsverfolgung, Bestellwesen und Nachschubplanung für optimierte Lagerhaltung.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <MessageCircle className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Support-Ticketsystem</h4>
              <p className="text-gray-600">
                Kundenanfragen effizient verfolgen, zuweisen und lösen mit integrierter Wissensdatenbank.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-5 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <FileText className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-2 text-blue-900">Dokumentenmanagement</h4>
              <p className="text-gray-600">
                Digitales Ablagesystem mit Versionskontrolle, Berechtigungsverwaltung und Suchfunktion.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProofSection; 